import { logout } from '@/api/server/user/read';
import { deleteStorage, localDeleteStorage } from './storage';
import BigNumber from 'bignumber.js';
export const copy = (_text: any) => {
  if (!_text) {
    return;
  }
  let textArea = document.createElement('textarea');
  textArea.value = _text;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  textArea.remove();
};

export const copys = async (_text: any) => {
  await navigator.clipboard.writeText(_text); // 클립보드에 텍스트 복사
};
export const nomalize = (aText: string, isSymbol: boolean): string => {
  let str = '';
  if (isSymbol) {
    str = aText.replace(/,/g, '');
  } else {
    str = aText;
  }
  return str;
};

export const decimalCnt = (aText: string): string => {
  const text = aText.split('.');
  const str = text[1].length > 2 ? text[1].substring(0, 2) : text[1];
  return str;
};
export const initStorage = () => {
  logout();
  deleteStorage('url');
  localDeleteStorage('auth');
};

export const checkPw = (aPw: string): boolean => {
  const reg = new RegExp('^(?=.*[A-Za-z])(?=.*d)(?=.*[@$!%*#?&])[A-Za-zd@$!%*#?&]{8,}$');
  if (!reg.test(aPw)) {
    alert('비밀번호 정규식 규칙 위반!!');
    return false;
  }
  return true;
};

export const changeLang = (aLang: string) => {
  aLang = aLang.toLowerCase();
  let lang = null;
  if (aLang === 'en-us' || aLang === 'en') {
    lang = 'EN';
  } else if (aLang === 'ko-kr' || aLang === 'ko') {
    lang = 'KO';
  } else {
    lang = 'EN';
  }
  return lang;
};

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

/**
 * 소수점 마지막에 0 제거
 * @param aValue 수량
 * @param digit (기본 2) 표시할 자릿수
 * @returns
 */
export const cutDecimalZero = (aValue: string, digit: number = 2): string => {
  const re = BigNumber(cutCommas(aValue))
    .toFormat(digit, 1)
    .replace(/\.?0+$/, '');
  return re;
};

// 콤마 제거
export const cutCommas = (aValue: string): string => {
  if (!aValue) return aValue;
  return aValue.replace(',', '');
};

// 천 단위 콤마 추가
export const addCommas = (aValue: string): string => {
  if (!aValue) return '0';
  const value = aValue;
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
